import Schema from 'AppReact/schema';
import { approvalCategory } from 'types';

export default {
  category: Schema(approvalCategory, 'object', { defaultValue: {} }),
  currentAmount: Schema('number', 'primitive', { defaultValue: 0 }),
}